import React from "react";
import useClockMetadataQuery from "../hooks/useClockMetadataQuery";
import { useUpdateClockMetadataMutation } from "../hooks/useUpdateClockMetadataMutation";
import { Device } from "../../../Types";
import DSTagList from "../../../views/system-design/DSTagList";
import { useAllClocksTagsQuery } from "../../../components/hooks";

export type ClockTagsProps = {
  clock: Device;
};

const ClockTags: React.FC<ClockTagsProps> = ({ clock }) => {
  const { data: clockMetadata, isLoading: metadataLoading } =
    useClockMetadataQuery(clock.id);
  const { mutateAsync: updateClockMetadata } = useUpdateClockMetadataMutation(
    clock.id,
  );

  const { data: allTags = [], isLoading: tagsLoading } =
    useAllClocksTagsQuery();

  const handleTagsSave = async (selectedTags: string[]) => {
    await updateClockMetadata({
      metadata: { tags: selectedTags },
    });
  };

  return (
    <DSTagList
      tags={clockMetadata?.tags || []}
      allTags={allTags}
      isLoading={tagsLoading}
      onSave={handleTagsSave}
      title="Clock Tags"
      showCopyButton
    />
  );
};

export default ClockTags;
